import { Injectable } from '@angular/core'
import { OCC_USER_ID_ANONYMOUS, UserIdService } from '@spartacus/core'
import { UserProfileService } from '@spartacus/user/profile/core'
import { Title } from '@spartacus/user/profile/root'
import { combineLatest, Observable, of } from 'rxjs'
import { map, switchMap } from 'rxjs/operators'
import { EbFormConfig } from '../../../../../form/interfaces/eb-form.interface'
import { EbPersonalInfoInterface } from '../../../../../support/common/interfaces/eb-common-form.interface'
import { EbCommonFormAdapter } from '../../../../../support/common/services/connectors/eb-common-form.adapter'

@Injectable()
export class EbUpdateProfileFormConfigService {
  constructor(
    protected userIdService: UserIdService,
    protected userProfileService: UserProfileService,
    protected ebCommonFormAdapter: EbCommonFormAdapter
  ) {}

  get formConfig$(): Observable<EbFormConfig> {
    return this.formConfigFactory()
  }

  private formConfigFactory(): Observable<EbFormConfig> {
    return combineLatest([this.getCustomerInfo(), this.getTitles()]).pipe(
      map(([customerInfo, titles]) => {
        return {
          steps: [
            {
              hideTitle: true,
              elements: [
                {
                  name: 'title',
                  type: 'field',
                  value: customerInfo.title || '',
                  fieldType: 'select',
                  required: true,
                  readonly: true,
                  options: titles.map(title => ({
                    name: title.code,
                    label: { default: title.name }
                  })),
                  placeholder: { default: '' }
                },
                {
                  name: 'firstName',
                  type: 'field',
                  value: customerInfo.firstName || '',
                  fieldType: 'input',
                  required: true,
                  readonly: true,
                  placeholder: { default: '' }
                },
                {
                  name: 'lastName',
                  type: 'field',
                  value: customerInfo.lastName || '',
                  fieldType: 'input',
                  required: true,
                  readonly: true,
                  placeholder: { default: '' }
                },
                {
                  name: 'email',
                  type: 'field',
                  value: customerInfo.email || '',
                  fieldType: 'input',
                  required: true,
                  readonly: true,
                  placeholder: { default: '' }
                },
                {
                  name: 'customerNumber',
                  type: 'field',
                  value: customerInfo.customerNumber || '',
                  fieldType: 'input',
                  readonly: true,
                  placeholder: { default: '' }
                },
                {
                  name: 'companyName',
                  type: 'field',
                  value: customerInfo.companyName || '',
                  fieldType: 'input',
                  readonly: true,
                  placeholder: { default: '' }
                }
              ]
            }
          ]
        }
      })
    )
  }

  getCustomerInfo(): Observable<EbPersonalInfoInterface> {
    return this.userIdService.getUserId().pipe(
      switchMap(userId => {
        if (userId !== OCC_USER_ID_ANONYMOUS) {
          return this.ebCommonFormAdapter.getCustomerInfo(userId)
        } else {
          return of({} as EbPersonalInfoInterface)
        }
      })
    )
  }

  getTitles(): Observable<Title[]> {
    return this.userProfileService.getTitles()
  }
}
